export const LogoMark = ({ className = "h-9 w-9" }) => (
  <img src="/zenura-logo.png" alt="" aria-hidden="true" className={`${className} object-contain`} data-testid="logo-mark" />
);

export const Logo = ({ light = false }) => (
  <span className="flex items-center gap-3">
    <LogoMark className="h-11 w-11" />
    <span className={`leading-none ${light ? "text-white" : "text-navy"}`}>
      <span className="block font-display text-[17px] font-extrabold tracking-[0.18em]">ZENURA</span>
      <span className={`block font-mono text-[10px] tracking-[0.42em] ${light ? "text-slate-300" : "text-slate-500"}`}>METALS</span>
    </span>
  </span>
);
